import VueRouter from 'vue-router';

class Dependency {
	private router: VueRouter | null = null;

	getRouter() {
		if(this.router === null) {
			throw new Error('Router not yet set');
		}
		return this.router;
	}

	setRouter(router: VueRouter) {
		this.router = router;
	}
}

export const DependencyService = new Dependency();
